import * as ss from 'superstruct';

/** Struct accepting any value of a string enum. */
export function fromEnum<EnumType extends string>(
  theEnum: Record<string, EnumType>,
): ss.Struct<EnumType, Record<EnumType, EnumType>> {
  return ss.enums(Object.values(theEnum));
}
